import axios from "axios";
import config from "../config";
import store from "../store/index";
import qs from "qs";
import app from "../main";
import notifyHelper from "./notifyHelper";
import dialogHelper from "./dialogHelper";
import router from "@/router/router";

export default {
    options: {
        contentType: "application/json",
        showNotifyConnectFailed: true,
        fail: null,
    },
    get: async function (url, data = {}, options) {
        return await this.sendRequest(url, data, "get", options);
    },
    delete: async function (url, data = {}, options) {
        return await this.sendRequest(url, data, "delete", options);
    },
    post: async function (url, data = {}, options) {
        return await this.sendRequest(url, data, "post", options);
    },
    put: async function (url, data = {}, options) {
        return await this.sendRequest(url, data, "put", options);
    },
    patch: async function (url, data = {}, options) {
        return await this.sendRequest(url, data, "patch", options);
    },
    sendRequest: async function (url, data = {}, method = "get", options = {}) {
        url = url.toLowerCase();
        const self = this;
        Object.keys(this.options).forEach(key => {
            if (typeof options[key] === "undefined" || options[key] == null)
                options[key] = self.options[key];
        })

        if (options.type === "formData") {
            options.contentType = "multipart/form-data";
            const formData = new FormData();
            for (const x in data) {
                if (Array.isArray(data[x])) {
                    const arr = data[x];
                    for (const y in arr) {
                        if (typeof arr[y] === "object") {
                            formData.append(x, JSON.stringify(arr[y]));
                        }
                        else {
                            formData.append(x, arr[y]);
                        }
                    }
                } else {
                    if (data[x] !== null)
                        formData.append(x, data[x]);
                }
            }
            data = formData;
        }

        let params = null;
        if (["get", "delete"].includes(method)) {
            params = {...data};
            data = null;
        }

        const headers = {
            "X-Requested-With": "XMLHttpRequest",
            "Access-Control-Allow-Origin": "*",
            "Content-Type": options.contentType
        };

        headers["Content-Language"] = {"vi": "vi-VN", "en": "en-US"}[options.language ||  store.getters["app/locale"]];
        const accessToken = store.getters["auth/accessToken"];

        if (accessToken)
            headers["Authorization"] = "Bearer " + accessToken;

        const response = await axios({
            baseURL: config.urls.api,
            method: method,
            url: url,
            data: data,
            headers: headers,
            responseType: "json",
            params: params,
            paramsSerializer: params => qs.stringify(params, {arrayFormat: "repeat"}),
            onUploadProgress: options.onUploadProgress
        }).catch(err => {
            if (options.showNotifyConnectFailed)
                notifyHelper.error("Connect to server failed. Please check your internet connection.");

            if (options.fail != null)
                options.fail();
        });
        if (response) {
            const data = response.data;
            if (data) {
                if (data.error) {
                    const code = data.code;
                    if (code === 401) {
                        await dialogHelper.alert(data.message);
                        window.location.href = config.urls.login;
                        return data;
                    }

                    if (code === 403) {
                        await dialogHelper.alert(data.message);
                        await app.$router.push({name: "Dashboard"});
                        return data;
                    }

                    if (code === 400) {
                        let message = data.message;
                        if (Array.isArray(data.data)) {
                            message = "<ul>"
                            data.data.forEach(error => message += `<li>${ error.message }</li>`)
                            message += "</ul>"
                        }

                        notifyHelper.error(message);
                        return data;
                    }

                    if (data.message && data.message.length)
                        notifyHelper.error(data.message);
                } else {
                    if (data.message && data.message.length)
                        notifyHelper.success(data.message);
                }

                return data;
            }
        }
      
        return {
            message: "Connect to server failed. Please check your internet connection.",
            code: 400,
            error: true,
            data: null
        };
    },
    fillParamUrl(url = "", param = null) {
        url = config.urls.api + url;
        if (!url) {
            throw new Error("Url is required");
        }

        url = url.toLowerCase();

        if (param) {
            url = /\?/.test(url) ? url += "&" : url += "?";
            url += new URLSearchParams(param).toString();
        }
        return url;
    }
}
